// extracted by mini-css-extract-plugin
export default {"cover":"_2nFvg","overlay":"_17FRC","content":"eGKnB"};